

















import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import DatePickerWithInput from "@/components/form/input/DatePickerWithInput.vue";

const module = namespace("projectValuationReport");

@Component({
  components: {
    DatePickerWithInput,
  },
})
export default class ProjectValuationPage3Edit extends Vue {
  @module.Getter("getMethodQuote") methodQuote!: string;

  @module.Mutation("setMethodQuote") setMethodQuote!: (value: string) => void;
}
